import type { PostHogErrorClassification } from './posthog-error-policy';

/** Known error shapes, first match wins (`classifyPostHogError`). */
export const CLASSIFICATION_RULES: Array<{
  classification: PostHogErrorClassification;
  pattern: RegExp;
}> = [
  {
    pattern: /FAL_ADMIN_KEY|falPayloadCleanup.*required/i,
    classification: {
      category: 'configuration',
      code: 'FAL_CLEANUP_CONFIGURATION_REQUIRED',
      expected: false,
      retryable: false,
      severity: 'fatal',
    },
  },
  {
    pattern: /FAL cleanup failed \(404\)|FAL cleanup.*request not found/i,
    classification: {
      category: 'dependency',
      code: 'FAL_CLEANUP_REQUEST_NOT_FOUND',
      expected: true,
      retryable: false,
      severity: 'warning',
    },
  },
  {
    pattern: /\bAUTH_REQUIRED\b|authentication required|not authenticated/i,
    classification: {
      category: 'access',
      code: 'AUTH_REQUIRED',
      expected: true,
      retryable: false,
      severity: 'warning',
    },
  },
  {
    pattern: /\bUNAUTHORIZED\b|\bFORBIDDEN\b|access denied/i,
    classification: {
      category: 'access',
      code: 'FORBIDDEN',
      expected: true,
      retryable: false,
      severity: 'warning',
    },
  },
  {
    pattern: /INSUFFICIENT_CREDITS|not enough credits|insufficient credits/i,
    classification: {
      category: 'resource',
      code: 'INSUFFICIENT_CREDITS',
      expected: true,
      retryable: false,
      severity: 'warning',
    },
  },
  // A team credit cap refusing work is policy, not a failure (#4626); the
  // code, not the needed amount in the message, keys the group.
  {
    pattern: /TEAM_CREDIT_LIMIT_EXCEEDED/,
    classification: {
      category: 'resource',
      code: 'TEAM_CREDIT_LIMIT_EXCEEDED',
      expected: true,
      retryable: false,
      severity: 'warning',
    },
  },
  {
    pattern: /ResizeObserver loop (?:limit exceeded|completed)/i,
    classification: {
      category: 'application',
      code: 'RESIZE_OBSERVER_LOOP',
      expected: true,
      retryable: false,
      severity: 'warning',
    },
  },
  {
    pattern: /cancell?ed by (?:the )?user|workflow was cancell?ed/i,
    classification: {
      category: 'user_action',
      code: 'USER_CANCELED',
      expected: true,
      retryable: false,
      severity: 'warning',
    },
  },
  {
    pattern: /Minified React error #185|maximum update depth exceeded/i,
    classification: {
      category: 'application',
      code: 'REACT_MAXIMUM_UPDATE_DEPTH',
      expected: false,
      retryable: false,
      severity: 'error',
    },
  },
  {
    pattern: /InvalidCursor|cursor is from a different query/i,
    classification: {
      category: 'application',
      code: 'PAGINATION_CURSOR_MISMATCH',
      expected: false,
      retryable: false,
      severity: 'error',
    },
  },
  {
    pattern: /update on nonexistent document/i,
    classification: {
      category: 'application',
      code: 'STALE_DOCUMENT_WRITE',
      expected: false,
      retryable: true,
      severity: 'error',
    },
  },
  {
    pattern:
      /fetch failed|service temporarily unavailable|timed? ?out|\b429\b|\b503\b/i,
    classification: {
      category: 'dependency',
      code: 'DEPENDENCY_UNAVAILABLE',
      expected: false,
      retryable: true,
      severity: 'error',
    },
  },
];
